import { html, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';

import '@shoelace-style/shoelace/dist/components/icon/icon.js';
import '@shoelace-style/shoelace/dist/components/progress-bar/progress-bar.js';

import { q1ProgressPanelStyles } from './q1-progress-panel-styles.js';

export class Q1ProgressPanel extends LitElement {
  static styles = [ q1ProgressPanelStyles ];

  static properties = {

    /**
     * The label to display in the progress panel.
     * 
     * Defaults to 'Processing...'.
     */
    label: { type: String, reflect: true },

    /**
     * The current progress as a percentage, 0 to 100.
     * 
     * Defaults to 0.
     */
    value: { type: Number, reflect: true },

    /**
     * Whether the progress panel is open or closed.
     * 
     * Defaults to false.
     */
    open: { type: Boolean, reflect: true },

    /**
     * Suppresses the overlay background when true.
     * 
     * Defaults to false.
     */
    noBackground: { type: Boolean, reflect: true, attribute: 'no-bg' },

  };

  constructor() {
    super();

    this.label = 'Processing...';
    this.value = 0;
    this.open = false;
    this.noBackground = false;
  }

  render() {
    return html`
      <outer-container part="base" class=${classMap({
        'progress--open': this.open,
        'progress--no-bg': this.noBackground,
      })}>
        <inner-container part="inner">
          <span part="label">${this.label}</span>
          <sl-progress-bar
            part="progress-bar"
            value=${this.value}
            label=${this.label}
          ></sl-progress-bar>
        </inner-container>
      </outer-container>
    `;
  }

}

customElements.define('q1-progress-panel', Q1ProgressPanel);
